module.exports = __webpack_public_path__ + "static/media/integration.ec08a2a2.jpg";